import React from 'react';
import Chart from 'react-google-charts';

const ColumnChartComponent = ({data,title,friend,userName,friendName,friendsData}) => {
  

  const colors=['#32cd32','#ffc01e','#e76f51']
  let main_data=[   ['Rating', 'Solved Problems', { role: 'style' }]]
  if(friend===false && data!==undefined && data!==null){
  const len=Object.keys(data).length/3
  let ind=0;
  main_data=[   ['Rating', 'Solved Problems', { role: 'style' }]]
  for(let key in data)
  {
    let col="";
    if(len>=ind)col=(colors[0]);
    else if(len<ind && ind<=2*len)col=(colors[1]);
    else col=(colors[2]);
    main_data.push([key,data[key],col])
    ind++;
  }
}else if(friend===false){
  main_data.push(['No Problems Solved',0,"#32cd32"])
}

if(friend===true && data!==undefined && data!==null){
  const len=Object.keys(data).length/3
  let ind=0;
  main_data=[ ['Rating', userName,friendName]]
  for(let key in data)
  {
    let col="";
    if(len>=ind)col=(colors[0]);
    else if(len<ind && ind<=2*len)col=(colors[1]);
    else col=(colors[2]);
    let count=(friendsData[key]===undefined || friendsData[key]===null)?0:friendsData[key];
    main_data.push([key,data[key],count])
    ind++;
  }
}else if(friend===true){
  main_data.push(['No Problems Solved',0,"#32cd32"])
}

let options = {
    title: title,
    titleTextStyle: {
      color: 'white',
      fontSize:15
    },
    vAxis: {
      title: 'Rating',
      textStyle: {
        color: 'white',
      },
      gridlines: {
        color: '#454545', // Remove vertical gridlines
      },
    },
    hAxis: {
      title: 'Number of Problems',
      textStyle: {
        color: 'white', // Set font color to white
      },
      gridlines: {
        color: 'transparent', // Remove horizontal gridlines
      },
    },
    legend: 'none',
    backgroundColor: { fill: '#282828' }, // Set background color
    animation: {
      startup: true,
      duration: 1000,
      easing: 'out',
    },
  };
  if(friend){
    options["colors"]=['#32cd32','#e76f51']
    options["legend"]={ position: 'top',alignment: 'end', textStyle: { color: 'white' }}
  }
  return (
    <div style={{ display: 'flex'}}>
      <Chart
        width={'100%'}
        height={'300px'}
        chartType="ColumnChart"
        loader={<div>Loading Chart</div>}
        data={main_data}
        options={options}
      />
    </div>
  );
};

export default ColumnChartComponent;
